import {DocumentNode, gql} from "@apollo/client";

export const SIGN_IN_MUTATION: DocumentNode = gql(`    
    mutation SignIn($signInDto: SignInRequest!) {
      signIn(signInDto: $signInDto) {
          ...AuthInfo
      }
    }
`);
